import React from 'react';
import MuxVideoPlayer from '../MuxPlayer';

const VideoPreviewAlt = React.memo(function VideoPreviewAlt({ mainVideo }) {
  if (mainVideo)
    return (
      <React.Fragment>
        <MuxVideoPlayer muxVideo={mainVideo} />
      </React.Fragment>
    );
  return null;
});

export default VideoPreviewAlt;
